import Toastr from '../../../itrust_common/components/Toastr';

const DEFAULT_STATE = {
  saving: false,
};

export default function claimAdjustmentReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response);

  switch (action.type) {
    case 'CLAIM_ADJUSTMENT_CREATE_PENDING':
    case 'CLAIM_ADJUSTMENT_UPDATE_PENDING':
    case 'CLAIM_ADJUSTMENT_DELETE_PENDING':
      return { ...state, saving: true };

    case 'CLAIM_ADJUSTMENT_CREATE_REJECTED':
    case 'CLAIM_ADJUSTMENT_UPDATE_REJECTED':
    case 'CLAIM_ADJUSTMENT_DELETE_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code);
      return { ...state, saving: false };

    case 'CLAIM_ADJUSTMENT_CREATE_FULFILLED':
    case 'CLAIM_ADJUSTMENT_UPDATE_FULFILLED':
    case 'CLAIM_ADJUSTMENT_DELETE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201);
      return { ...state, saving: false };

    default:
      return state;
  }
}
